import manifest from './assets/manifest.json'

// iOS ignores the manifest `splash_screens` key — launch images must be declared
// as <link rel="apple-touch-startup-image" media="..."> tags. Build them from the
// same manifest data so there is a single source of truth.
const appleStartupImages = (manifest.splash_screens || []).map((screen, index) => ({
  vmid: `apple-startup-${index}`,
  rel: 'apple-touch-startup-image',
  href: screen.src,
  media: screen.media
}))

const preloadedFonts = [
  ['font-regular', require('./assets/fonts/TTNorm/TTNormsPro-Regular.woff2')],
  ['font-medium', require('./assets/fonts/TTNorm/TTNormsPro-Medium.woff2')]
].map(([vmid, href]) => ({
  vmid,
  rel: 'preload',
  href,
  as: 'font',
  type: 'font/woff2',
  crossorigin: 'anonymous'
}))

export default {
  title: 'Korzyna',
  titleTemplate: '%s',
  htmlAttrs: {
    lang: 'uk'
  },
  meta: [
    { charset: 'utf-8' },
    { vmid: 'description', name: 'description', content: 'Доставка товарів' },
    { name: 'robots', content: 'index, follow' },
    { name: 'application-name', content: 'Korzyna' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-title', content: 'Korzyna' },
    { name: 'theme-color', content: '#ffffff' },
    // Valid values are: default | black | black-translucent (a color is invalid here)
    { name: 'apple-mobile-web-app-status-bar-style', content: 'default' }
  ],
  link: [
    ...preloadedFonts,
    { rel: 'manifest', href: '/assets/manifest.json' },
    { rel: 'icon', type: 'image/png', sizes: '96x96', href: '/assets/images/icons/icon-96x96.png' },
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/assets/images/icons/apple-touch-icon.png' },
    ...appleStartupImages
  ]
}
